import { ISpecifiedItemTypeSummary } from '@nibtravel/shared/util/models';

export namespace UiContextActions {
  /** Action to show the send quote email form */
  export class ToggleSendEmailForm {
    public static readonly type = '[Ui Context] Toggle email form';
  }

  /** Action to hide the send quote email form */
  export class HideSendEmailForm {
    public static readonly type = '[Ui Context] Hide email form';
  }

  export class ShowEmailSentSuccessful {
    public static readonly type = '[Ui Context] Show email success';
  }

  export class SendAnotherEmail {
    public static readonly type = '[Ui Context] Send another email';
  }

  export class PageChanged {
    public static readonly type = '[Ui Context] Page Changed';
  }

  export class ShowSpecifiedItem {
    public static readonly type = '[Ui Context] Show Specified Item';
    constructor(public item: ISpecifiedItemTypeSummary) {}
  }

  export class ToggleSpecifiedItem {
    public static readonly type = '[Ui Context] Toggle Specified Item';
    constructor(public item: ISpecifiedItemTypeSummary) {}
  }

  export class ResetSpecifiedItem {
    public static readonly type = '[Ui Context] Reset Specified Item';
  }
  /** Action to show/hide the promocode input form using the promo-code link */
  export class TogglePromoCodeForm {
    public static readonly type = '[Ui Context] Toggle Promo code form';
  }

  export class TogglePromoCodeSuccess {
    public static readonly type =
      '[Ui Context] Toggle Promo Code Success Message';
    constructor(public display: boolean) {}
  }

  export class TogglePromoCodeFailure {
    public static readonly type =
      '[Ui Context] Toggle Promo Code Failure Message';
    constructor(public display: boolean) {}
  }

  export class SetQqcAlertMessage {
    public static readonly type = '[Ui Context] Qqc Alert Message';

    constructor(public alertMessage: string) {}
  }

  export class ResetQqcAlertMessage {
    public static readonly type = '[Ui Context] Qqc Alert Message Reset';
  }

  /** Action that stores the selected trip based on the radio config  */
  export class SetTravellerAgeSelection {
    public static readonly type = '[Ui Context] Set traveller age selection';
    constructor(public radioId: string) {}
  }
}
